export default __webpack_public_path__ + "static/media/honeywell-logo-white.995b6270.svg";